<template>
  <div :class="[`row-item-container`,
  `row-item-container-${ domTitle }`,
   { 'is-active-list' : isActiveFullInfo }]"
       :style="{'--custom-children-height' : `${ activeHeightBlock }px`,
       '--custom-parent-height' : `${ activeHeightStatic }` }">
    <div class="row-item-top-container">
      <div class="left-container">
        <main-title class="main-wrapper-title">
          {{ title || '\u200B' }}
        </main-title>
        <slot name="subTitle"/>
      </div>
      <div class="right-container">
        <transition-group name="fade-opacity-lazy">
          <div class="actions-content"
               v-for="item in actions"
               @click="activateAction(item)"
               :key="item.id">
            <icon-default v-if="item.type === 'edit' || item.type === 'remove' || item.type === 'download'"
                          :color="'dark-green'"
                          :size="'small'">
              <component :is="item.icon"/>
            </icon-default>
            <button-main  v-else-if="item.type === 'btn'">
              {{ item.btnText }}
            </button-main>
            <button-show :is-active="item.active"
                         v-else-if="item.type === 'view' && !isActiveFullInfo">
              {{ item.btnText }}
            </button-show>
            <icon-default v-else-if="item.type === 'view' && isActiveFullInfo"
                          :color="'dark-green'"
                          :size="'small'">
              <IconDownload/>
            </icon-default>
          </div>
        </transition-group>

      </div>
    </div>
    <div :class="[`row-item-bottom-container`, `row-item-bottom-container-${ domTitle }`,
    { 'is-active-list' : isActiveFullInfoChildren }]">
      <slot name="rowItem"/>
    </div>
  </div>
</template>

<script>
import MainTitle from "@/components/shared/text/MainTitle.vue";
import IconEdit from "@/assets/icons/ui/edit.svg?inline"
import IconRemove from "@/assets/icons/ui/delete.svg?inline"
import IconDownload from "@/assets/icons/ui/download.svg?inline"
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import ButtonShow from "@/components/shared/buttons/ButtonShow.vue";
export default {
  name: "RowItem",
  components: {ButtonShow, ButtonMain, IconDefault, MainTitle, IconEdit, IconRemove, IconDownload},
  props: {
    isMountedActiveRow: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    domTitle: {
      type: String,
      default: 'default'
    },
    activeCRUD: {
      type: Array,
      default: () => {
        return [
          {
            type: 'download',
            action: () => console.log('download')
          },
          {
            type: 'view',
            action: () => console.log('view')
          },
          {
            type: 'edit',
            action: () => console.log('edit')
          },
          {
            type: 'remove',
            action: () => console.log('remove')
          },
          {
            btnText: 'btn text',
            type: 'btn',
            action: () => console.log('btn')
          },
        ]
      }
    },
    isActiveCloseOut: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.checkSizeContainer();
    this.checkParentSize(true);
    if(this.isMountedActiveRow) {
      this.changeStateRow();
    }
    addEventListener('resize', this.checkSizeContainer);
  },
  unmounted() {
    removeEventListener('resize', this.checkSizeContainer);
  },
  data() {
    return {
      isActiveFullInfo: false,
      isActiveFullInfoChildren: false,
      timer: null,
      activeHeightBlock: 0,
      activeHeightStatic: 56
    }
  },
  watch: {
    isActiveCloseOut() {
      console.log('a')
      if(this.isActiveCloseOut) {
        this.changeStateRow();
      }
    }
  },
  computed: {
    actionsStatic() {
      return {
        view: {
          id: 0,
          iconActiveList: IconDownload
        },
        edit: {
          id: 1,
          icon: IconEdit,
        },
        remove: {
          id: 2,
          icon: IconRemove,
        },
        btn: {
          id: 3
        },
        download: {
          id: 4,
          icon: IconDownload,
        },
      }
    },
    actions() {
      let actions = this.activeCRUD.map(item => {
        let itemCRUD = this.actionsStatic[item.type];
        return {
          ...item,
          ...itemCRUD
        }
      })
      if(this.isMountedActiveRow) {
        return actions.filter(item => item.type === 'remove');
      }
      return this.isActiveFullInfo
          ? actions.filter(item => item.type !== 'btn')
          : actions
    }
  },
  methods: {
    activateAction(item) {
      if(item.type === 'edit' && !item?.action) {
        this.changeStateRow();
      } else if(item.action) {
        item.action()
      }
    },
    checkParentSize(isMounted = false) {
      this.activeHeightStatic = 'auto'
      let parentHeight = document.querySelector(`.row-item-container-${ this.domTitle }`)?.clientHeight
      if(parentHeight) {
        this.activeHeightStatic = `${ parentHeight }px`;
      }
    },
    checkSizeContainer() {
      let childrenHeight = document.querySelector(`.row-item-bottom-container-${ this.domTitle }`)?.clientHeight
      if(childrenHeight) {
        this.activeHeightBlock = childrenHeight;
      }
    },
    changeStateRow() {
      clearTimeout(this.timer)
      if(this.isActiveFullInfo) {
        this.isActiveFullInfo = false;
        this.isActiveFullInfoChildren = false
      } else {
        if(!this.disabled) {
          this.checkSizeContainer();
          this.isActiveFullInfo = true;
          this.timer = setTimeout(() => {
            this.isActiveFullInfoChildren = true
          }, 300)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .row-item-container {
    width: 100%;
    transition: all .3s ease;
    border-radius: 10px;
    --active-padding-top: 32px;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    height: calc(var(--custom-parent-height)  - var(--custom-children-height));
    background: rgba(var(--color-grey-rgba), 0.2);


    &.is-active-list {
      overflow: hidden;
      background: rgba(var(--color-purple-rgba), .3);
      height: calc(var(--custom-parent-height) + var(--active-padding-top));

      &:hover {
        background: rgba(var(--color-purple-rgba), .3);
      }
    }

    .row-item-bottom-container {
      position: relative;
      pointer-events: none;
      z-index: 0;
      transition: all .3s ease;
      opacity: 0;
      bottom: 0;
      left: 0;
      margin-top: 0;

      &:before {
        background: rgba(var(--color-light-purple-rgba), .2);
        top: calc(var(--active-padding-top) / 2);
        content: "";
        height: 1px;
        width: 100%;
        position: absolute;
      }
      &.is-active-list {
        pointer-events: visible;
        padding-top: var(--active-padding-top);
        z-index: 1;
        opacity: 1;
      }
    }


    &:hover {
      background: rgba(207, 215, 209, 0.4);
      .left-container {
        .main-title-container {
          color: var(--color-white);
        }
      }
    }
    .row-item-top-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      @media(max-width: 769px) {
        flex-direction: column;
        row-gap: 12px;
        align-items: flex-start;
      }

      .left-container {
        .main-title-container {
          transition: all .3s ease;
          color: var(--color-dark-green);
        }
      }
      .right-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 16px;

        .actions-content {
          position: relative;
          .icon-container {
            cursor: pointer;
          }
        }
      }
    }

  }
</style>